import s from './DieselGeneratorSlideCard.module.scss';
import Image from "next/image";
import {TDieselGeneratorSlideCardProps} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/types";

export const DieselGeneratorSlideCard = ({ label, task, solution, image }: TDieselGeneratorSlideCardProps) => {
    return (
        <div className={s.card}>
            <div className={s.card_imageContainer}>
                <Image src={image} alt={label}/>
            </div>

            <div className={s.card_content}>
                <label>{label}</label>
                <p>
                    <span>Task</span>
                    { task }
                </p>
                <p>
                    <span>Solution</span>
                    { solution }
                </p>
            </div>
        </div>
    );
};